import { render, staticRenderFns } from "./AllRecordTaskCompletedNotification.vue?vue&type=template&id=340b8cce&scoped=true&"
import script from "./AllRecordTaskCompletedNotification.vue?vue&type=script&lang=js&"
export * from "./AllRecordTaskCompletedNotification.vue?vue&type=script&lang=js&"
import style0 from "./AllRecordTaskCompletedNotification.vue?vue&type=style&index=0&id=340b8cce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340b8cce",
  null
  
)

export default component.exports